import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: '2px',
    marginBottom: '4px',
    padding: '0 4px',
    textAlign: 'center',
    textDecoration: 'underline',
    cursor: 'pointer',
    color: theme.palette.primary.main,
    minWidth: 0,
    flexShrink: 0,
    maxWidth: '100%'
  }
}))

export default useStyles
